import React, { Fragment } from "react";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { brands } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useFormikContext } from "formik";
import {
    FacebookPreview,
    TwitterPreview,
    SearchPreview,
} from "@automattic/social-previews";
import { modal } from "components/HeadlessModal";
import PrimaryButton from "components/Buttons/PrimaryButton";

function SocialPreviews(props) {
    const { values } = useFormikContext();

    const showSocialPreview = (platform) => {
        const title = values.seo_title ? values.seo_title : values.title;
        const desc = values.seo_description
            ? values.seo_description
            : values.abstract
            ? values.abstract
            : "No abstract or SEO description found. CEO will generate one automatically from content on publishing.";
        const image = values.seo_url
            ? values.seo_url
            : values.dominantAttachment
            ? values.dominantAttachment.attachment.imgix_url +
              "?w=500&dpr=2&ar=16:9&fit=crop&crop=faces"
            : null;
        const author = values.authors
            ? values.authors.map((author) => author.value).join(", ")
            : null;

        let card;
        if (platform === "facebook") {
            card = (
                <FacebookPreview
                    title={title}
                    description={desc}
                    image={image}
                    author={author}
                    type="article"
                />
            );
        } else if (platform === "twitter") {
            const template = {
                date: Date.now(),
                name: "SNworks Preview",
                profileImage:
                    "https://static.getsnworks.com/placeholder/assets/img/cube-flat.png",
                screenName: "@getsnworks",
            };
            card = (
                <TwitterPreview
                    tweets={[
                        {
                            ...template,
                            text: `${title}\n\n${desc}`,
                            media: image
                                ? [
                                      {
                                          alt: "Alt text",
                                          url: image,
                                          type: "image/jpeg",
                                      },
                                  ]
                                : null,
                        },
                    ]}
                />
            );
        } else if (platform === "google") {
            card = (
                <SearchPreview
                    title={title}
                    description={desc}
                    image={image}
                    author={author}
                />
            );
        }

        modal({
            title: "Social Previews",
            children: (
                <Fragment>
                    <div className="mb-4 text-sm text-gray-800">
                        This is a representation of what your content{" "}
                        <em>should</em> look like on different social media
                        platforms. The final result may be somewhat different
                        depending on the platform and your site's template.
                    </div>
                    <div className="flex justify-center">
                        <div className="rounded border-gray-100 p-4 shadow-lg">
                            {card}
                        </div>
                    </div>
                </Fragment>
            ),
            buttons: () => (
                <PrimaryButton onClick={modal.dismiss}>Done</PrimaryButton>
            ),
        });
    };

    return (
        <div>
            <div className="flex justify-center space-x-4">
                <SecondaryButton
                    onClick={() => showSocialPreview("google")}
                    label={
                        <Fragment>
                            <FontAwesomeIcon
                                className="pr-2 text-google"
                                icon={brands("google")}
                            />
                            Preview Google Search Result
                        </Fragment>
                    }
                />
                <SecondaryButton
                    onClick={() => showSocialPreview("facebook")}
                    label={
                        <Fragment>
                            <FontAwesomeIcon
                                className="pr-2 text-facebook"
                                icon={brands("facebook")}
                            />
                            Preview Facebook Card
                        </Fragment>
                    }
                />
                <SecondaryButton
                    onClick={() => showSocialPreview("twitter")}
                    label={
                        <Fragment>
                            <FontAwesomeIcon
                                className="pr-2 text-twitter"
                                icon={brands("twitter")}
                            />
                            Preview Twitter Card
                        </Fragment>
                    }
                />
            </div>
        </div>
    );
}

export default SocialPreviews;
